export const environment = {

  baseUrl: 'https://amaplan-stage.amazone.de/api',

    googleMapsApiKey: "AIzaSyA20rk39bDp0tJAUZC9IyIB_P8Yy3vSRkA",

    // Url of the Identity Provider
    issuer: 'https://login-stage.amazone.de/cas/oidc',

    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '',

    // The SPA's id. The SPA is registerd with this id at the auth-server
    // clientId: 'server.code',
    clientId: '3nTfgqrAcovqF3PPRpuY',



    // Just needed if your auth server demands a secret. In general, this
    // is a sign that the auth server is not configured with SPAs in mind
    // and it might not enforce further best practices vital for security
    // such applications.
    clientSecret: 'mUoa6QBKLrP9K2zA3qFn9ZeLf9wE3c',

    responseType: 'code',

    useHttpBasicAuth: true,

    // set the scope for the permissions the client should request
    // The first four are defined by OIDC.
    // Important: Request offline_access to get a refresh token
    // The api scope is a usecase specific one
    //scope: 'openid profile email offline_access api',
    scope: 'openid profile offline_access 3nTfgqrAcovqF3PPRpuY',

    showDebugInformation: true
};
